import React, { useState } from "react";
import { Button, Grid, TextField } from "@mui/material";
import { Cancel as CancelIcon } from "@mui/icons-material";
import {
  AnimatedModal,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "../../components/modals/AnimatedModal";

const CancelLabelModal = ({ isOpen, onClose, label, onSuccess }) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReasonChange = (value) => {
    setReason(value);

    const hasError = error !== "";
    if (hasError) {
      setError("");
    }
  };

  const validateForm = () => {
    const hasNoReason = !reason.trim();
    if (hasNoReason) {
      setError("O motivo do cancelamento é obrigatório");
      return false;
    }

    const isReasonTooShort = reason.trim().length < 10;
    if (isReasonTooShort) {
      setError("O motivo deve ter pelo menos 10 caracteres");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    const isFormValid = validateForm();
    if (!isFormValid) {
      return;
    }

    try {
      setLoading(true);

      const cancelData = {
        labelId: label.id,
        reason: reason.trim(),
        cancelledAt: new Date().toISOString(),
      };

      onSuccess("Etiqueta cancelada com sucesso!", cancelData);
      onClose();
      setReason("");
      setError("");
    } catch (err) {
      console.error("Erro ao cancelar etiqueta:", err);
      setError("Falha ao cancelar. Por favor, tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setReason("");
    setError("");
    onClose();
  };

  return (
    <AnimatedModal
      isOpen={isOpen}
      onClose={handleClose}
      width="600px"
      maxWidth="95%"
      zIndex={1400}
    >
      <ModalHeader
        title="Cancelar Etiqueta Vencida"
        icon={CancelIcon}
        onClose={handleClose}
      />
      <ModalContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Produto"
              value={label?.productName || ""}
              disabled
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Lote"
              value={label?.batchNumber || ""}
              disabled
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Motivo do Cancelamento"
              required
              multiline
              rows={4}
              value={reason}
              onChange={(e) => handleReasonChange(e.target.value)}
              variant="outlined"
              error={!!error}
              helperText={
                error ||
                "Explique o motivo do cancelamento (mínimo 10 caracteres)"
              }
              disabled={loading}
              placeholder="Ex: Produto vencido e descartado conforme procedimento..."
            />
          </Grid>
        </Grid>
      </ModalContent>
      <ModalFooter>
        <Button
          variant="outlined"
          onClick={handleClose}
          sx={{ mr: 1 }}
          disabled={loading}
        >
          Voltar
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleSubmit}
          disabled={loading || !reason.trim()}
        >
          {loading ? "Cancelando..." : "Confirmar Cancelamento"}
        </Button>
      </ModalFooter>
    </AnimatedModal>
  );
};

export default CancelLabelModal;
